<template>
  <div class="outer">

    <div class="row editor">
      <div class="editor__image">
        <div class="editor__image--inner">
          <vue-cropper v-if="imgSrc"
            class="editor__image--cropper"
            :viewMode="2"
            :autoCrop="false"
            :autoCropArea="0.9"
            :checkCrossOrigin="true"
            crossOrigin="anonymous"
            ref="cropper"
            :src="imgSrc"
            alt="Source Image"
            :cropmove="cropImage"
          />
        </div>
      </div>
      <div class="editor__controls">
        <q-btn
          @click="setCropperMode('move')"
          :color="cropperMode === 'move' ? 'primary' : 'ctrl-turquoise'"
          icon="open_with"
        />
        <q-btn
          @click="cropperMode === 'crop' ?  update() : setCropperMode('crop')"
          :color="cropperMode === 'crop' ? 'primary' : 'ctrl-turquoise'"
          :icon="cropperMode === 'crop' ? 'check' : 'crop'"
        />
        <q-btn
          @click="rotateImage(45)"
          :color="cropperMode === 'rotate-right' ? 'primary' : 'ctrl-turquoise'"
          icon="rotate_right"
        />
        <q-btn
          @click="rotateImage(-45)"
          :color="cropperMode === 'rotate-left' ? 'primary' : 'ctrl-turquoise'"
          icon="rotate_left"
        />
        <q-btn
          @click="flipImgage('x')"
          :color="cropperMode === 'flipX' ? 'primary' : 'ctrl-turquoise'"
          icon="flip"
        />
        <q-btn
          class="rotate"
          @click="flipImgage('y')"
          :color="cropperMode === 'flipY' ? 'primary' : 'ctrl-turquoise'"
          icon="flip"
        />
        <q-btn
          @click="initFocus()"
          :color="cropperMode === 'focus' ? 'primary' : 'ctrl-turquoise'"
          :icon="cropperMode === 'focus' ? 'check' : 'filter_center_focus'"
        />
        <!-- <q-btn
          @click="undo()"
          :color="history.index > 0 ? 'ctrl-turquoise' : 'grey-5'"
          :disable="history.index === 0"
          icon="undo"
        />
        <q-btn
          @click="redo()"
          :color="history.index === history.operations.length ? 'grey-5' : 'ctrl-turquoise'"
          :disable="history.index === history.operations.length"
          icon="redo"
        /> -->
      </div>
      <div class="row info">
        <q-input color="primary"
          class="q-ml-md q-mr-md"
          :readonly="true"
          v-model="image.width"
          :float-label="getString('module.library.details.file.image.width')"
        />
        <q-input color="primary"
          class="q-ml-md q-mr-md"
          :readonly="true"
          v-model="image.height"
          :float-label="getString('module.library.details.file.image.height')"
        />
        <q-input color="primary"
          :readonly="true"
          class="q-ml-md q-mr-md"
          v-model="image.focusPoint.x"
          type="number"
          :float-label="'Focuspoint X'"
        />
        <q-input color="primary"
          :readonly="true"
          class="q-ml-md q-mr-md"
          v-model="image.focusPoint.y"
          :float-label="'Focuspoint Y'"
        />
        <div class="info__save q-pt-md">
          <q-btn
            class="capitalize ctrl-button q-ml-md"
            color="warning"
            :label="getString('module.library.button.editor.cancel')"
            @click="cancelEdit()"
          />
          <q-btn
            class="capitalize ctrl-button right q-ml-md"
            :color="!cropperMode ? 'ctrl-turquoise' : 'grey-5'"
            :disable="!!cropperMode"
            :label="getString('module.library.button.editor.save')"
            @click="save()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import qs from 'qs';
import _debounce from 'lodash.debounce';

import getString from '@/helpers/GetStrings';
import common from '@/mixins/library/common';

export default {
  mixins: [
    common,
  ],
  components: {
    VueCropper,
  },
  data() {
    return {
      cropped: false,
      focuspointSet: false,
      previewSave: false,
      imgSrc: null,
      image: {
        width: 0,
        height: 0,
        focusPoint: {
          x: 0,
          y: 0,
        },
      },
      cropperData: {},
      setFocus: false,
      history: {
        index: 0,
        operations: [],
      },
      flip: {
        x: 1,
        y: 1,
      },
      cropperMode: null,
      cropImage: null,
    };
  },
  methods: {
    getString,
    cancelEdit() {
      this.$router.go(-1);
    },
    setCropperMode(mode) {
      this.setFocus = false;
      this.removeFocusStyle();
      this.$refs.cropper.clear();
      if (this.cropperMode === mode) {
        this.cropperMode = null;
        return;
      }
      this.$refs.cropper.initCrop();
      this.cropperMode = mode;
      this.$refs.cropper.setCropBoxData(this.cropperData);
      this.$refs.cropper.setDragMode(mode);
    },
    rotateImage(angle, history) {
      this.cropped = true;
      this.$refs.cropper.rotate(angle);
      !history && this.addToHistory({ rotate: angle });
    },
    flipImgage(axis, history) {
      this.cropped = true;
      if (axis === 'x') {
        this.flip.x *= -1;
        this.$refs.cropper.scaleX(this.flip.x);
        !history && this.addToHistory({ flipX: this.flip.x });
      }
      if (axis === 'y') {
        this.flip.y *= -1;
        this.$refs.cropper.scaleY(this.flip.y);
        !history && this.addToHistory({ flipY: this.flip.y });
      }
    },

    update() {
      const filetype = this.determineFileType(this.$route.params.filename);
      const newImg = this.$refs.cropper.getCroppedCanvas().toDataURL(filetype);

      this.imgSrc = newImg;
      this.$refs.cropper.replace(newImg);
      this.updateImageData();
      this.cropperMode = null;
      this.cropped = true;
    },

    // Reads a file and returns the filetype. eg. 'image/jpeg'
    determineFileType(file) {
      let filetype;
      const ext = file.split('.').pop().split('/')[0];

      switch (ext) {
        case 'jpeg':
        case 'jpg':
          filetype = 'image/jpeg';
          break;
        case 'png':
          filetype = 'image/png';
          break;
        case 'svg':
          filetype = 'image/svg+xml';
          break;
        case 'tiff':
        case 'tif':
          filetype = 'image/tiff';
          break;
        case 'gif':
          filetype = 'image/gif';
          break;
        case 'bmp':
          filetype = 'image/bpm';
          break;
        case 'ico':
          filetype = 'image/vnd.microsoft.icon';
          break;
        default:
          filetype = '';
          break;
      }
      return filetype;
    },

    async save() {
      // check if the focuspoint has been saved
      if (this.focuspointSet) {
        await this.axios.put(`/library/${decodeURIComponent(this.$route.params.filename)}`,
          qs.stringify({
            focuspoint_x: this.image.focusPoint.x,
            focuspoint_y: this.image.focusPoint.y,
          }), { headers: { 'Content-Disposition': 'inline' } });
      }

      if (this.cropped) {
        const filetype = this.determineFileType(this.$route.params.filename);
        // Store a base64 string in img variable.
        const img = this.$refs.cropper.getCroppedCanvas().toDataURL(filetype);
        const old = decodeURIComponent(this.$route.params.filename);

        this.axios.put(`/library/${old}`,
          qs.stringify({ modified: img }),
          { headers: { 'Content-Disposition': 'inline' } })
          .then((res) => {
            if (res.data && res.data.location) {
              // Build the new filename (location stays the same)
              const aOld = old.split('/');
              aOld.splice(aOld.length - 1, 1, res.data.location);
              const edited = aOld.join('/');
              this.$router.push(`/library/${encodeURIComponent(edited)}`);
            } else {
              // Throw an error
              throw new Error();
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        this.$router.push(`/library/${encodeURIComponent(this.$route.params.filename)}`);
      }
    },

    fetchFileDetails(filename) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await this.axios.get(`library/${filename}`);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },

    buildFileLocation(location) {
      return location && `${process.env.VUE_APP_API_URL}${location.replace('api/library', 'library/download')}`;
    },

    fetchLibraryFile(filename) {
      this.fetchFileDetails(filename)
        .then((res) => {
          this.file = res.data.file;
          const focusPoint = res.data.file.focuspoint;
          this.image.focusPoint.x = focusPoint.x;
          this.image.focusPoint.y = focusPoint.y;

          this.imgSrc = this.buildFileLocation(res.data.file.location);
        })
        .catch((error) => {
          console.warn(error);
        });
    },

    _base64ToArrayBuffer(base64) {
      const binaryString = window.atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i += 1) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      return bytes.buffer;
    },

    removeFocusStyle() {
      this.$refs.cropper.clear();
      const elements = document.querySelectorAll('[ref=focus]');
      for (let i = 0; i < elements.length; i += 1) {
        elements[i].setAttribute('ref', 'crop');
      }
      setTimeout(() => {
        // Re-initialize the cropper
        this.$refs.cropper.initCrop();
      }, 10);
    },

    styleFocusPoint() {
      // First remove cropbox to avoid seeing the cropbox transform.
      this.$refs.cropper.clear();
      // Add focus point styling to the crop-box
      const focus = document.getElementsByClassName('cropper-view-box')[0];
      focus.setAttribute('ref', 'focus');

      const center = document.getElementsByClassName('cropper-center')[0];
      center.setAttribute('ref', 'focus');

      // Remove the drag action on the canvas
      const drag = document.getElementsByClassName('cropper-drag-box')[0];
      drag.setAttribute('style', 'cursor: default;');
      drag.removeAttribute('data-cropper-action');


      const lines = document.getElementsByClassName('cropper-line');
      const points = document.getElementsByClassName('cropper-point');
      const dashed = document.getElementsByClassName('cropper-dashed');

      if (lines.length) {
        for (let i = 0; i < lines.length; i += 1) {
          lines[i].setAttribute('ref', 'focus');
        }
      }
      if (dashed.length) {
        for (let i = 0; i < dashed.length; i += 1) {
          dashed[i].setAttribute('ref', 'focus');
        }
      }
      if (points.length) {
        for (let i = 0; i < points.length; i += 1) {
          points[i].setAttribute('ref', 'focus');
        }
      }

      // This is called on the next tick
      setTimeout(() => {
        // Re-initialize the cropper
        this.$refs.cropper.initCrop();
        const container = this.$refs.cropper.getContainerData();
        const image = this.$refs.cropper.getImageData();
        const canvas = this.$refs.cropper.getCanvasData();

        const centerX = container.width / 2;
        const centerY = container.height / 2;

        const offsetX = canvas.left - centerX + (canvas.width / 2);
        const offsetY = canvas.top - centerY + (canvas.height / 2);

        this.$refs.cropper.setCropBoxData({
          left: centerX + offsetX + (this.image.focusPoint.x * (image.width / 2)) - 75,
          top: centerY + offsetY + (this.image.focusPoint.y * (image.height / 2)) - 75,
          width: 150,
          height: 150,
        });
      }, 10);
    },

    initFocus() {
      if (this.cropperMode === 'focus') {
        this.$refs.cropper.clear();
        this.cropperMode = null;
        this.setFocus = false;
        this.focuspointSet = true;
      } else {
        this.styleFocusPoint();
        this.cropperMode = 'focus';
        this.setFocus = true;
      }
    },

    setFocusPoint: _debounce(function () {
      if (this.$refs.cropper) {
        const image = this.$refs.cropper.getImageData();
        const canvas = this.$refs.cropper.getCanvasData();
        const cropbox = this.$refs.cropper.getCropBoxData();
        if (this.setFocus) {
          const x = 2 * ((cropbox.left - canvas.left + (cropbox.width / 2)) / image.width - 0.5);
          const y = 2 * ((cropbox.top - canvas.top + (cropbox.height / 2)) / image.height - 0.5);
          // Set focuspoint
          [this.image.focusPoint.x, this.image.focusPoint.y] = [x.toFixed(3), y.toFixed(3)];
        }
      }
    }, 100),

    updateImageData: _debounce(function (initialLoad) {
      // Do not add initialization to history
      if (!initialLoad) {
        this.history.operations.push('cropmove');
      }
      if (this.$refs.cropper) {
        this.cropperData = this.$refs.cropper.getCroppedCanvas();
        this.image.width = this.cropperData.width.toFixed(0);
        this.image.height = this.cropperData.height.toFixed(0);
      }
    }, 100),

    cropmove() {
      if (this.setFocus) {
        this.setFocusPoint();
      } else {
        this.updateImageData();
      }
    },

    undo() {
      this.history.index -= 1;
      this.applyOperation(-1);
    },

    redo() {
      this.applyOperation(1);
      this.history.index += 1;
    },

    addToHistory(operation) {
      this.history.operations.push(operation);
      this.history.index += 1;
    },

    applyOperation(dir) {
      const operation = Object.keys(this.history.operations[this.history.index])[0];
      const value = Object.values(this.history.operations[this.history.index])[0];

      // Appplies undo/redo operations
      switch (operation) {
        case 'flipX':
          this.flip.x = dir * -value;
          this.flipImgage('x', true);
          break;
        case 'flipY':
          this.flip.y = dir * -value;
          this.flipImgage('y', true);
          break;
        case 'rotate':
          this.rotateImage(dir * value, true);
          break;
        default:
          break;
      }
    },
  },

  computed: {
    canSave() {
      // Determines whether saving is possible
      // There should be changes and there should be a crop-box initialized (not in focus mode)
      return this.history.operations.length > 0 && !this.setFocus;
    },
  },

  created() {
    window.addEventListener('cropmove', this.cropmove, true);
  },
  destroyed() {
    window.removeEventListener('cropmove', this.cropmove, true);
  },
  mounted() {
    this.fetchLibraryFile(decodeURIComponent(this.$route.params.filename));
    if (this.$refs.cropper) {
      this.updateImageData(true);
      this.$refs.cropper.clear();
    }
  },
};
</script>

<style lang="stylus">
.row.info
  width 100%
  // &__save

.outer
  height 100%
.info
  justify-content space-between
  margin 2rem 0
.editor
  background #fff
  padding 1rem
  border 1px solid #dedede
  border-radius 4px
  width 100%
  height auto
  display flex
  justify-content space-between
  &__image
    display flex
    max-height 100%
    height 100%
    width calc(100% - 55px)
    justify-content center
    &--inner
      border-radius 4px
      max-height 100%
      width 100%
      max-width 100%
    &--cropper
      width 100%
      height calc(100vh - 280px)
  &__controls
    display flex
    flex-direction column
    justify-content flex-start
    button
      width 38px
      margin-bottom 16px
      padding 4px
      &.rotate
        -webkit-transform: rotate(90deg)
        -moz-transform: rotate(90deg)
        -ms-transform: rotate(90deg)
        -o-transform: rotate(90deg)
        transform: rotate(90deg)
.cropper-face
  opacity 0 !important

[ref='focus']
  &.cropper-line
  &.cropper-point
  &.cropper-dashed
    visibility hidden
  &.cropper-center
    margin-top -3px
    margin-left -3px
  &.cropper-view-box
    margin-top -3px
    margin-left -3px
    display block
    height 100%
    outline none
    overflow hidden
    width 100%
    border-radius 50%
    border 3px solid yellow

.cropper-point
  height 30px !important
  width 30px !important
  opacity 0 !important
  background-color #888
  border-radius 50%
  &.point-nw
  &.point-w
  &.point-sw
    margin-left -15px
  &.point-ne
  &.point-e
  &.point-se
    margin-right -15px
  &.point-nw
  &.point-n
  &.point-ne
    margin-top -15px
  &.point-sw
  &.point-s
  &.point-se
    margin-bottom -15px
.cropper-line
  background-color #888

.cropper-view-box
    outline 1px solid #888
    outline-color #888

.cropper-dashed
    border: 0 dashed #888;
    opacity: 0.5;
</style>
